module.exports = __webpack_public_path__ + "img/env_10.d6226c56.jpg";